import { Stack } from '@mui/material'
import { OperacionLCLSCuentaLimitesAprobadosPais } from 'src/pages/sistema/sistemas/lcls/types/dto'
import { OperacionLCLSLimitesAprobadosPaisFields, OperacionLCLSLimitesAprobadosUnidadNegocioFields } from 'src/pages/sistema/sistemas/lcls/types/fields'
import { SistemaTipo } from 'src/types/enum/enum'
import CardLimite from '../CardLimite'
import UnidadNegocioLCLS from './UnidadNegocioLCLS'

interface LimiteLCLSProps {
    data: OperacionLCLSCuentaLimitesAprobadosPais
}

function LimiteLCLS({ data }: LimiteLCLSProps) {
    return (
        <Stack gap={1}>
            <CardLimite
                codSistema={SistemaTipo.LCLS}
                codPais={data[OperacionLCLSLimitesAprobadosPaisFields.CodPais]}
                pais={data[OperacionLCLSLimitesAprobadosPaisFields.NombrePais]}
            />

            {data[OperacionLCLSLimitesAprobadosPaisFields.ListaUnidadesNegocio].map((unidad, index) => (
                <UnidadNegocioLCLS key={`unidad-negocio-${unidad[OperacionLCLSLimitesAprobadosUnidadNegocioFields.CodUnidadNegocio]}-${index}`} data={unidad} />
            ))}
        </Stack>
    )
}

export default LimiteLCLS
